import type SponsorStrapi from "~/libs/interfaces/SponsorStrapi";
import type SponsorLocal from "~/libs/interfaces/SponsorLocal";

const sponsorLocalFactory = {
  createSponsorFromStrapi(sponsor?: SponsorStrapi): SponsorLocal | undefined {
    if (!sponsor) {
      return undefined;
    }
    return {
      id: sponsor.id,
      documentId: sponsor.documentId,

      createdAt: sponsor.createdAt ? new Date(sponsor.createdAt) : undefined,
      updatedAt: sponsor.updatedAt ? new Date(sponsor.updatedAt) : undefined,
      publishedAt: sponsor.publishedAt ? new Date(sponsor.publishedAt) : undefined,

      name: sponsor.name,
      image: sponsor.image,
      isVisible: sponsor.isVisible,
      link: sponsor.link,
      order: sponsor.order || 1,
    }
  }
}
export default sponsorLocalFactory